
import React from 'react';
import { FormControl } from "@material-ui/core";
import { FormContext } from 'core/FormProvider';
import {ContextFormControlWidget, ContextWidget} from 'form/Contexed';
import FormGroup from 'form/FormGroup';
import { InputWidget } from 'form/InputWidget';
import { InputNumberWidget } from "form/InputWidget";
import {AsyncAutocompleteWidget} from 'form/AutocompleteWidget';
import {DateTimeWidget} from 'form/new/DateTimeWidget';
import { DatetimeActions } from 'form/DatetimeActions';
import {SelectButtonGroupWidget} from 'form/SelectButtonGroupWidget';
import {CheckboxWidget} from "form/Checkbox";


export function ScheduleForm() {
  return (
    <FormContext.Consumer>
      {context => {
        const { item } = context;
        const canDateStartEdit = item.can_date_start_edit;

        return (
          <FormGroup>

            <ContextFormControlWidget
              name={'status'}
              WidgetComponent={SelectButtonGroupWidget}
              widgetProps={{
                disabled: item.id > 0,
                label: 'Статус',
                options: [
                  {label: 'Работает', value: 'WORKING'},
                  {label: 'Не работает', value: 'NOT_WORKING'},
                ]
              }}
            />

            <ContextFormControlWidget
              name={'date_start'}
            >
              <DateTimeWidget
                value={item.date_start}
                label={'Дата начала'}
                disabled={!canDateStartEdit}
                onChange={(value, stringValue) => context.setDateTimeValue('date_start', value)}
              />
              {canDateStartEdit && (
                <div className={'mt-5'}>
                  <DatetimeActions
                    value={item.date_start}
                    onChange={(value) => context.setDateTimeValue('date_start', value)}
                  />
                </div>
              )}
            </ContextFormControlWidget>

            {!item.is_unlimited && (
              <ContextFormControlWidget
                name={'date_end'}
              >
                <DateTimeWidget
                  value={item.date_end}
                  label={'Дата окончания'}
                  onChange={(value, stringValue) => context.setDateTimeValue('date_end', value)}
                />
                <div className={'mt-5'}>
                  <DatetimeActions
                    value={item.date_end}
                    onChange={(value) => context.setDateTimeValue('date_end', value)}
                    roundingMinutes={60}
                  />
                </div>
              </ContextFormControlWidget>
            )}

            <FormControl>
              <CheckboxWidget
                value={item.is_unlimited}
                onChange={(value) => context.setValue('is_unlimited', value)}
                label={'Бессрочная связка'}
              />
            </FormControl>

            {(item.id === undefined || item.tractor_unit !== null) && (
              <ContextFormControlWidget
                name={'tractor_unit'}
                WidgetComponent={AsyncAutocompleteWidget}
                widgetProps={{
                  label: 'Транспортное средтсво',
                  url: 'fleet/truck/?is_active=True',
                  optionLabel: 'label',
                  disabled: item.id !== undefined
                }}
              />
            )}

            {(item.id === undefined || item.driver !== null) && (
              <ContextFormControlWidget
                name={'driver'}
                WidgetComponent={AsyncAutocompleteWidget}
                widgetProps={{
                  label: 'Водитель',
                  url: 'fleet/driver/?is_fired=False',
                  optionLabel: 'full_name',
                  disabled: item.id !== undefined
                }}
                disabled={item.id !== undefined}
              />
            )}

            {(item.id === undefined || item.semi_trailer !== null) && (
              <ContextFormControlWidget
                name={'semi_trailer'}
                WidgetComponent={AsyncAutocompleteWidget}
                widgetProps={{
                  label: 'Полуприцеп',
                  url: 'fleet/trailer/?is_active=True',
                  optionLabel: 'label',
                  disabled: item.id !== undefined
                }}
              />
            )}

            <ContextWidget
              name={`max_weight`}
              WidgetComponent={InputNumberWidget}
              widgetProps={{
                label: 'Максимально допустимый вес'
              }}
            />

            <ContextWidget
              name={`comment`}
              WidgetComponent={InputWidget}
              widgetProps={{
                label: 'Комментарий',
                multiline: true
              }}
            />

          </FormGroup>
        )
      }}
    </FormContext.Consumer>
  )
}
